import React, { useState } from "react";
import { LockKeyhole, Menu, Phone, ShieldCheck, X } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

const LINKS = [
  ["#manifesto", { en: "01 / Approach", es: "01 / Método" }, "approach"],
  ["#our-work", { en: "02 / Our work", es: "02 / Nuestro trabajo" }, "our-work"],
  ["#estimate", { en: "03 / Estimate", es: "03 / Cotización" }, "estimate"],
  ["#services", { en: "04 / Services", es: "04 / Servicios" }, "services"],
  ["#contact", { en: "05 / Contact", es: "05 / Contacto" }, "contact"],
];

export default function Header({ settings, language, setLanguage, mode, setMode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const phoneHref = `tel:${settings.phone.replace(/[^0-9+]/g, "")}`;

  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <a className="brand-link" href="#top" data-testid="brand-home-link" onClick={closeMenu}>
          <BrandLogo settings={settings} language={language} />
        </a>
        <span className="header-status" data-testid="insurance-status"><ShieldCheck size={14} /> {settings.insurance_statement?.[language] || (language === "en" ? "We carry insurance" : "Contamos con seguro")}</span>
        <nav className="header-nav" aria-label="Primary navigation">
          {LINKS.map(([href, label, key]) => (
            <a className="nav-link" href={href} key={key} data-testid={`nav-${key}-link`}>
              {label[language]}
            </a>
          ))}
        </nav>
        <div className="header-actions">
          <div className="mode-switcher" aria-label="Thermal mode">
            <button className={`mode-button ${mode === "heat" ? "active" : ""}`} type="button" onClick={() => setMode("heat")} data-testid="thermal-mode-heat-btn">
              {language === "en" ? "Heat" : "Calor"}
            </button>
            <button className={`mode-button ${mode === "cool" ? "active" : ""}`} type="button" onClick={() => setMode("cool")} data-testid="thermal-mode-cool-btn">
              {language === "en" ? "Cool" : "Frío"}
            </button>
          </div>
          <button className="language-button" type="button" onClick={() => setLanguage(language === "en" ? "es" : "en")} data-testid="language-toggle-btn" aria-label="Switch language">
            {language.toUpperCase()}
          </button>
          <a className="icon-button" href="/admin" aria-label="Open admin portal" data-testid="admin-portal-open-btn">
            <LockKeyhole />
          </a>
          <a className="header-call" href={phoneHref} data-testid="header-call-button">
            <Phone />
            <span>{language === "en" ? "Call" : "Llamar"}</span>
          </a>
          <button className="mobile-menu-button" type="button" onClick={() => setMenuOpen((open) => !open)} aria-label="Toggle menu" data-testid="mobile-menu-toggle-btn">
            {menuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="mobile-menu" data-testid="mobile-navigation-menu">
          {LINKS.map(([href, label, key]) => (
            <a className="nav-link" href={href} key={key} onClick={closeMenu} data-testid={`mobile-nav-${key}-link`}>
              {label[language]}
            </a>
          ))}
          <div className="mobile-menu-tools">
            <div className="mode-switcher" aria-label="Thermal mode mobile">
              <button className={`mode-button ${mode === "heat" ? "active" : ""}`} type="button" onClick={() => setMode("heat")} data-testid="mobile-thermal-mode-heat-btn">{language === "en" ? "Heat" : "Calor"}</button>
              <button className={`mode-button ${mode === "cool" ? "active" : ""}`} type="button" onClick={() => setMode("cool")} data-testid="mobile-thermal-mode-cool-btn">{language === "en" ? "Cool" : "Frío"}</button>
            </div>
            <a className="icon-button" href="/admin" aria-label="Open admin portal mobile" data-testid="mobile-admin-portal-open-btn"><LockKeyhole /></a>
          </div>
        </div>
      )}
    </header>
  );
}
